<template>
  <div>
    <!-- current active user  -->
    <div
      class="admin__container overflow-hidden py-5 px-lg-5"
      v-if="
        userAssignments &&
        userAssignments.length > 0 &&
        Object.keys(userData).length > 0
      "
    >
      <div class="relative admin__container__main shadow rounded-lg">
        <div class="details__container">
          <div class="details__picture">
            <img
              v-if="userData.profilePictureUrl"
              class="rounded-circle __img"
              :src="`${constants.s3Bucket}/editor/profile-pictures/${userData.profilePictureUrl}`"
              alt="Profile Picture"
            />

            <img
              v-else
              class="rounded-circle __img"
              :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                userData.firstName || 'boringAvatar',
                userData.lastName || 'boringAvatar'
              )}`"
              alt="Profile Picture"
            />
          </div>

          <div class="details__information">
            <div class="main__info">
              <h3>
                {{ userData.firstName }}
                {{ userData.lastName }}
              </h3>
              <h6>
                {{ userData.profession }}
              </h6>
            </div>

            <!-- <div class="skills__info">
                <h6>Skill</h6>
  
                <div>
                  <span>Figma</span>
                  <span>Adobe Illustrator </span>
                  <span>Office 365</span>
                </div>
              </div> -->

            <div class="contact__info">
              <div class="contact__details">
                <img
                  src="@/assets/images/icons/org-review/iconEmail.svg"
                  alt="email"
                />

                <div>
                  {{ userData.email }}
                </div>
              </div>

              <!-- <div class="contact__details">
                  <img
                    :src="
                      require(`@/assets/images/icons/org-review/iconPhone.svg`)
                    "
                    alt="phone"
                  />
  
                  <a>+12 345 6789 0</a>
                </div> -->
            </div>
          </div>
        </div>

        <div class="treasury__container">
          <h3>Wallet</h3>

          <h4>
            {{ xp }}
            XP
          </h4>

          <!-- <h4>
            {{ gold }}
            Gold
          </h4> -->

          <div class="treasury__information">
            <div class="treasury__information__1">
              <!-- <h6>Pending Validation</h6>
                <h5>40 XP</h5> -->
            </div>

            <div class="treasury__information__2">
              <!-- <h6>Successful Distributions</h6>
                <h5>6000 XP</h5> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- item to review  -->
    <!-- Skeleton  -->
    <div v-if="assignmentLoading">
      <div
        v-for="i in 5"
        :key="i"
        class="border border-blue-300 shadow rounded-lg p-4 w-full animate-pulse h-48 my-6"
        style="background: #8080805e"
      ></div>
    </div>
    <div v-else-if="userAssignments.length > 0 && !assignmentLoading">
      <div class="flex justify-end">
        <vs-button
          @click="acceptAllItems = true"
          :class="isDisableAcceptBtn ? 'opacity-50 pointer-events-none' : ''"
          >Approve All Validations</vs-button
        >
      </div>
      <div>
        <single-task-card
          v-for="assignment in userAssignments"
          :key="assignment.itemId"
          :assignment="assignment"
          :isDisableAcceptBtn="isDisableAcceptBtn"
        />
      </div>
    </div>
  </div>
</template>

<script>
import constants from "@/constants";
import SingleTaskCard from "../components/SingleTaskCard.vue";

export default {
  data() {
    return {
      constants,
      routeToLink: false,
      userAssignments: [],
      orgId: "",
      assignmentLoading: true,
      userData: {},
      userProfilePic: "",
      userName: "",
      xp: 0,
      gold: 0,
      acceptAllItems: false,
      isDisableAcceptBtn: true,
    };
  },
  components: {
    SingleTaskCard,
  },
  computed: {
    orgData() {
      return this.$store.state.organization.orgData;
    },
    loggedUserData() {
      return this.$store.state.users.data;
    },
    avatarNameGenerator() {
      return this.$store.state.users.avatarNameGenerator;
    },
  },
  watch: {
    orgData: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal && Object.keys(oldVal).length > 0) {
          this.getUserItems(newVal._id);
          this.orgId = newVal._id;
        }
      },
      deep: true,
      setImmediate: true,
    },
    acceptAllItems(newVal) {
      if (newVal) {
        let acceptedAssignmentIdsArray = [];
        for (let i = 0; i < this.userAssignments.length; i++) {
          if (
            this.userAssignments[i].feedLibraryItemStatus === "done" &&
            this.userAssignments[i].libraryItemValidationData &&
            Object.keys(this.userAssignments[i].libraryItemValidationData)
              .length > 0
          ) {
            acceptedAssignmentIdsArray.push(this.userAssignments[i].itemId);
          }
        }
        const payload = {
          libraryItemIds: acceptedAssignmentIdsArray,
          reviewStatus: "ACCEPTED",
          gtbrddOrganizationId: this.orgData._id,
          gtbrddUserId: this.$route.query.userId,
        };
        this.$store
          .dispatch("alex/reviewAssignment", payload)
          .then((res) => {
            if (res) {
              this.userAssignments = this.userAssignments.filter(
                (item) => !acceptedAssignmentIdsArray.includes(item.itemId)
              );
            }
          })
          .catch((err) => {
            // console.log(err);
          });
      }
    },
    userAssignments: {
      deep: true,
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          let validatingItems = [];
          for (let i = 0; i < newVal.length; i++) {
            console.log(newVal[i]);
            if (
              newVal[i].feedLibraryItemStatus === "done" &&
              newVal[i].libraryItemValidationData &&
              Object.keys(newVal[i].libraryItemValidationData).length > 0
            ) {
              validatingItems.push(newVal[i].itemId);
            }
          }
          this.isDisableAcceptBtn = validatingItems.length > 0 ? false : true;
        }
      },
    },
  },
  created() {
    this.getUserItems(this.orgData._id);
  },
  methods: {
    getUserItems(orgId) {
      if (orgId) {
        const payload = {
          orgId: orgId,
          userId: this.$route.query.userId,
        };
        this.$store
          .dispatch("alex/getUserItems", payload)
          .then((res) => {
            if (res && res.data && res.data.length > 0) {
              this.userData = res.data.find(
                (obj) => "userData" in obj
              ).userData;

              this.$store
                .dispatch("users/getUserTokens", {
                  userId: this.userData._id,
                })
                .then((res) => {
                  if (res && res.data && res.data.aggregatedWallet) {
                    for (let i = 0; i < res.data.aggregatedWallet.length; i++) {
                      if (res.data.aggregatedWallet[i].tokenKey === 0) {
                        this.xp = res.data.aggregatedWallet[i].tokenValueSum;
                      } else if (res.data.aggregatedWallet[i].tokenKey === 2) {
                        this.gold = res.data.aggregatedWallet[i].tokenValueSum;
                      }
                    }
                  }
                })
                .catch(() => {});

              this.userAssignments = res.data;
            }
          })
          .catch((err) => {
            this.$router.push({
              name: "org-reviews",
            });
          })
          .finally(() => {
            this.assignmentLoading = false;
          });
      }
    },
    getAssignedUser(id) {
      this.$store
        .dispatch("users/getAssignedUser", id)
        .then((res) => {
          this.userProfilePic = res.profilePictureUrl
            ? res.profilePictureUrl
            : "";
          if (
            res.firstName === this.loggedUserData.firstName &&
            res.lastName === this.loggedUserData.lastName
          ) {
            this.userName = "you";
          } else {
            this.userName = `${res.firstName} ${
              res.lastName ? res.lastName : ""
            }`;
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../reviewBase.scss";
.admin__container {
  &__main {
    .details__container {
      .details__picture {
        .__img {
          border-color: #0ba5ec;
        }
      }
    }
  }
}
</style>
